import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { SERVICES_CONSTANTS } from '../utils/constants';
import { StringUtils } from '../utils/stringUtils';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  baseUrl: string;

  constructor(
    private http: HttpClient,
    private stringUtils: StringUtils
  ) {
    this.baseUrl = environment.baseUrl;
  }

  getCategories() {
    const url = this.stringUtils.buildUrl(
      this.baseUrl,
      SERVICES_CONSTANTS.CATEGORIES_PATH.MAIN,
      SERVICES_CONSTANTS.CATEGORIES_PATH.CATREGORIES
    );
    return this.http.get<any>(url);
  }

  getPublicCategories() {
    const url = this.stringUtils.buildUrl(
      this.baseUrl,
      SERVICES_CONSTANTS.PUBLIC_CATEGORIES_PATH.MAIN,
      SERVICES_CONSTANTS.PUBLIC_CATEGORIES_PATH.CATEGORIES
    );
    return this.http.get<any>(url);
  }
}
